import { IDashboardConfig, IDashboardConfigSlice } from './types';
import moment from 'moment/moment';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { INTERNAL_DATE_FORMAT } from '../../../config/constants';

// sensible defaults to avoid nullable config.{defaultStart,defaultEnd}
const now = moment().format(INTERNAL_DATE_FORMAT);

const defaultConfig: IDashboardConfig = {
  __typename: 'DashboardConfig',
  defaultStart: now,
  defaultEnd: now,
  defaultDatePicker: {
    __typename: 'DatePickerFixed',
    start: now,
    end: now,
  },
  logicOps: [],
};

const initialState: IDashboardConfigSlice = {
  config: defaultConfig,
  isLoaded: false,
};

export default createSlice({
  name: 'dashboardConfig',
  initialState,
  reducers: {
    loadDashboardConfig: (state, action: PayloadAction<IDashboardConfig>) => {
      state.config = action.payload;
      state.isLoaded = true;
    },
  },
});
